import { render, staticRenderFns } from "./Name.vue?vue&type=template&id=b622bf96&"
import script from "./Name.vue?vue&type=script&lang=ts&"
export * from "./Name.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports